import React from "react";

import { Link } from "react-router-dom";
// reactstrap components
import {
  Button,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  UncontrolledTooltip,
} from "reactstrap";

function IndexNavbar() {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 399 ||
        document.body.scrollTop > 399
      ) {
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < 400 ||
        document.body.scrollTop < 400
      ) {
        setNavbarColor("navbar-transparent");
      }
    };
    window.addEventListener("scroll", updateNavbarColor);
    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });
  return (
    <>
      {collapseOpen ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setCollapseOpen(false);
          }}
        />
      ) : null}
      <Navbar className={"fixed-top bg-white"} expand="lg">
        <Container>
          <div className="navbar-translate">
            <NavbarBrand href="/" id="navbar-brand">
              <img
                alt="logo"
                src={require("assets/img/fibs_logo_red.png")}
                style={{
                  height: 50,
                }}
              />
            </NavbarBrand>
            {/* <UncontrolledTooltip target="#navbar-brand">
                Designed by 
              </UncontrolledTooltip> */}
            <button
              className="navbar-toggler navbar-toggler"
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setCollapseOpen(!collapseOpen);
              }}
              aria-expanded={collapseOpen}
              type="button"
            >
              <span className="navbar-toggler-bar top-bar"></span>
              <span className="navbar-toggler-bar middle-bar"></span>
              <span className="navbar-toggler-bar bottom-bar"></span>
            </button>
          </div>
          <Collapse
            className="justify-content-end"
            isOpen={collapseOpen}
            navbar
          >
            <Nav navbar className="subheader">
              {/* <NavItem>
                <NavLink to="/" tag={Link}>
                  HOME
                </NavLink>
              </NavItem> */}
              <NavItem>
                <NavLink to="/about-macau" tag={Link}>
                  ABOUT Macau
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/agenda" tag={Link}>
                  AGENDA
                </NavLink>
              </NavItem>
              {/* <NavItem>
                <NavLink to="/meeting-cost" tag={Link}>
                  Meeting Cost
                </NavLink>
              </NavItem>  */}
              <NavItem>
                <NavLink to="/visa" tag={Link}>
                  VISA
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/hotel" tag={Link}>
                  HOTEL
                </NavLink>
              </NavItem>
              {/* <NavItem>
                <NavLink to="/post-event-2023" tag={Link}>
                  Post-Event 2023
                </NavLink>
              </NavItem>             */}
              <UncontrolledDropdown nav>
                <DropdownToggle
                  caret
                  color="default"
                  href="#ivyauxilio"
                  nav
                  onClick={(e) => e.preventDefault()}
                >
                  {/* <i className="now-ui-icons design_app mr-1"></i> */}
                  <p>Post-Event</p>
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem to="/post-event-2023" tag={Link}>
                    <i className="now-ui-icons files_box mr-1"></i>
                    <span className="mt-1">Dubai 2023</span>
                  </DropdownItem>
                  <DropdownItem to="/post-event-2025" tag={Link}>
                    <i className="now-ui-icons files_box mr-1"></i>
                    <span className="mt-1">Vietnam 2025</span>
                  </DropdownItem>
                  <DropdownItem to="/post-event-2026" tag={Link}>
                    <i className="now-ui-icons files_box mr-1"></i>
                    <span className="mt-1">Macau 2026</span>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              {/* <NavItem>
                <NavLink to="/post-event-2025" tag={Link}>
                  Post-Event 2025
                </NavLink>
              </NavItem>  */}
              {/* <NavItem>
                <NavLink to="/registration" tag={Link}>
                  REGISTER
                </NavLink>
              </NavItem> */}
              {/* <NavItem>
                <NavLink to="/gallery" tag={Link}>
                  GALLERY
                </NavLink>
              </NavItem> */}
              <NavItem>
                <NavLink to="/contact-us" tag={Link}>
                  CONTACT US
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="/sponsorship"
                  id="sponsor"
                  tag={Link}
                  className="nav-link btn-outline-danger btn"
                >
                  <i className="now-ui-icons users_single-02 mr-1"></i>
                  <p>Be a sponsor</p>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="/registration"
                  tag={Link}
                  id="register"
                  className="nav-link btn-danger btn text-white"
                >
                  <i className="now-ui-icons arrows-1_share-66 mr-1"></i>
                  <p>Register</p>
                </NavLink>
              </NavItem>
              {/* <NavItem>
                <NavLink
                  href="#"
                  target="_blank"
                  id="linkedin-tooltip"
                >
                  <i className="fa-brands fa-linkedin-in bg-danger text-white" style={{ padding: "10px", borderRadius: "20px" }}></i> 
                  <p className="d-lg-none d-xl-none"> Linkedin</p>
                </NavLink>
              </NavItem> */}
              {/* <NavItem>
                <NavLink
                  href="#"
                  target="_blank"
                  id="twitter-tooltip"
                >
                  <i className="fab fa-twitter"></i>
                  <p className="d-lg-none d-xl-none">Twitter</p>
                </NavLink>
                <UncontrolledTooltip target="#twitter-tooltip">
                  Follow us on Twitter
                </UncontrolledTooltip>
              </NavItem>
              <NavItem>
                <NavLink
                  href="#"
                  target="_blank"
                  id="facebook-tooltip"
                >
                  <i className="fab fa-facebook-square"></i>
                  <p className="d-lg-none d-xl-none">Facebook</p>
                </NavLink>
                <UncontrolledTooltip target="#facebook-tooltip">
                  Like us on Facebook
                </UncontrolledTooltip>
              </NavItem>
              <NavItem>
                <NavLink
                  href="#"
                  target="_blank"
                  id="instagram-tooltip"
                >
                  <i className="fab fa-instagram"></i>
                  <p className="d-lg-none d-xl-none">Instagram</p>
                </NavLink>
                <UncontrolledTooltip target="#instagram-tooltip">
                  Follow us on Instagram
                </UncontrolledTooltip>
              </NavItem> */}
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default IndexNavbar;
